import type { BackgroundNoImageProtocol } from '@lighthouse/core'
import { useMemo } from 'react'

import { useAppThemeContext } from '../../components'
import { getTextColorStyle } from '../../utils'

export const useLabelStyle = (labelColor?: BackgroundNoImageProtocol) => {
    const { theme } = useAppThemeContext()
    return useMemo(() => getTextColorStyle(labelColor, theme.palettes), [labelColor, theme.palettes])
}
